'use client'

import { useLatestCallback } from '@marketplace-web/shared/ui-state'
import { getSessionDefaults } from '@marketplace-web/domain/catalog-data'
import {
  useCatalogContext,
  ConfigurationReducerAction,
} from '@marketplace-web/domain/catalog-page-data'

const useFetchCatalogConfigurations = () => {
  const { dispatch } = useCatalogContext()

  const fetchCatalogConfigurations = useLatestCallback(async () => {
    dispatch({ type: ConfigurationReducerAction.FETCH_CONFIG_REQUEST, payload: undefined })

    const response = await getSessionDefaults()

    if ('errors' in response) {
      dispatch({ type: ConfigurationReducerAction.FETCH_CONFIG_FAILURE, payload: undefined })
    } else {
      dispatch({
        type: ConfigurationReducerAction.FETCH_CONFIG_SUCCESS,
        payload: response.session_defaults_configuration,
      })
    }
  })

  return fetchCatalogConfigurations
}

export default useFetchCatalogConfigurations
